import React from 'react';
import ProjectsHub from '../projects/ProjectsHub';

interface MemberProjectsProps {
    memberData?: any;
}

const MemberProjects: React.FC<MemberProjectsProps> = ({ memberData }) => {
    const memberId = memberData?.id || 'member-id-placeholder';

    return (
        <div className="min-h-screen bg-gray-50">
            <ProjectsHub memberId={memberId} />
        </div>
    );
};

export default MemberProjects;